jQuery( document ).ready( function ( $ ) {
	class JOURNALCOMPARISON {
		constructor( thisInstance ) {
			this.version = '1.23'
			console.log( '[JTF Gut Block - JS] jtf/jtf-journals-comparison v' + this.version )

			this.instance = thisInstance
			this.blocktype = thisInstance.attr( 'data-blocktype' )
			this.buttonColour = thisInstance.attr( 'data-buttoncolor' ).replace( '#', '' )
			this.highlightColour = thisInstance.attr( 'data-highlightcolor' ).replace( '#', '' )
			this.dataPoint = {
				acceptance: {
					label: 'acceptance',
					sliderValue: 0,
				},
				citescore: {
					label: 'citescore',
					sliderValue: 0,
				},
				if: {
					label: 'if',
					sliderValue: 0,
				},
				ifbq: {
					label: 'ifbq',
					sliderValue: 0,
				},
				if5: {
					label: 'if5',
					sliderValue: 0,
				},
				snip: {
					label: 'snip',
					sliderValue: 0,
				},
				sjr: {
					label: 'sjr',
					sliderValue: 0,
				},
				firstdec: {
					label: 'firstdec',
					sliderValue: 0,
				},
				postdec: {
					label: 'postdec',
					sliderValue: 0,
				},
				onlinepub: {
					label: 'onlinepub',
					sliderValue: 0,
				},
				downloads: {
					label: 'downloads',
					sliderValue: 0,
				},
				citequart: {
					label: 'citequart',
					sliderValue: 0,
				},
				oa: {
					label: 'oa',
					sliderValue: 0,
				},
			}
			this.clickMap()

			if ( this.blocktype !== 'preset' ) {
				this.ajaxJournals()
			}

			this.setRangeMax()
			this.firstFilter = ''
			this.secondFilter = ''
			this.thirdFilter = ''
			this.resultsCounter = 1
			this.reduceResults()
		}

		ajaxJournals = function ( category ) {
			const self = this
			const xhr = new XMLHttpRequest()

			xhr.open(
				'GET',
				'/wp-content/themes/JTF3/Pro/core/ajax_comparison_block.php?category='
				+ category + '&buttoncolour=' + self.buttonColour + '&highlightcolour=' + self.highlightColour,
			)
			xhr.onload = function ( response ) {
				if ( xhr.status === 200 ) {
					self.instance.find( '.journalcomparison__content--container' ).html( JSON.parse( response.currentTarget.response ) )
					self.instance = self.instance.find( '.journalcomparison__content--container' ).parents( '.wp-block-jtf-jtf-journalcomparison' )
					self.setRangeMax()
					self.reduceResults()
				}
			}
			xhr.send()
		}

		clickMap = function () {
			const self = this

			self.instance.find( '.journalcomparison__subjectcategories' ).on( 'change', function () {
				self.reorderResults()
			} )

			self.instance.find( '.journalcomparison__manualsubjects' ).on( 'change', function () {
				const parentElement = $( this ).val()
				const datalistValue = self.instance.find( '#journalcomparison__manual--category option' ).filter( function () {
					return this.value == parentElement
				} ).data( 'value' )

				self.ajaxJournals( datalistValue )
			} )


			self.instance.find( '.journalcomparison__datalist--reset' ).on( 'click', function () {
				self.instance.find( '.journalcomparison__subjectcategories' ).val( '' )
			} )

			self.instance.find( '.journalcomparison__datalist--reset-subject' ).on( 'click', function () {
				self.instance.find( '.journalcomparison__manualsubjects' ).val( '' )
				self.instance.find( '.journalcomparison__content--container' ).html( '' )
			} )

			self.instance.find( '.journalcomparison__content--filter-range' ).on( 'input', function () {
				const thisType = $( this ).attr( 'data-range' )
				self.instance.find( '.journalcomparison__content--filter-rangevalue[data-range="' + thisType + '"]' ).html( $( this ).val() )
			} )

			self.instance.find( '.journalcomparison__content--filter-range' ).on( 'change', function () {
				self.hideJournal()
			} )

			self.instance.find( '.journalcomparison__check--trigger' ).on( 'change', function () {
				const target = $( this ).attr( 'data-target' )
				const checked = $( this ).is( ':checked' )
				const totalCheckedFilters = self.instance.find( '.journalcomparison__check--trigger:checked' ).length

				if ( totalCheckedFilters == 0 ) {
					$( '.journalcomparison__content--item-disable' ).removeClass( 'journalcomparison__content--item-disable' )
				}

				self.setFilterCounts( checked, target )
			} )

			self.instance.find( ".journalcomparison__loadmore--button" ).on( 'click', function () {
				self.resultsCounter = self.resultsCounter + 1
				let visibleItemsBefore = $( ".journalcomparison__content--item" ).not( '.journalcomparison__content--item-disable' ).not( '.journalcomparison__content--restrict' ).length
				self.reduceResults()

				let resultCounter = 0
				for ( let x = 0; x < $( ".journalcomparison__content--item" ).length; x++ ) {
					let thisEle = $( ".journalcomparison__content--item:nth-of-type( " + x + " )" )
					if ( thisEle.hasClass( 'journalcomparison__content--item-disable' ) > 0 || thisEle.hasClass( 'journalcomparison__content--restrict' ) > 0 ) {
						//item has been disabled either because filter doesn't match, or it's not in the loaded 12 blocks
					} else {
						if ( resultCounter == visibleItemsBefore + 1 ) {
							thisEle.find( '.journalcomparison__content--item-button' ).focus()
						}

						resultCounter = resultCounter + 1
					}
				}
			} )
		}

		/**
		 * restrict number of journals loaded to 12 in a block - this is a visual restriction only, the blocks are just hidden until 'load more'
		 */
		reduceResults = function () {
			const self = this
			let counter = 0

			self.instance.find( '.journalcomparison__content--item' ).not( '.journalcomparison__content--item-disable' ).each( function () {
				$( this ).removeClass( 'journalcomparison__content--restrict' )
				counter++
				let currentJournalCount = self.resultsCounter * 12

				if ( counter > currentJournalCount ) {
					$( this ).addClass( 'journalcomparison__content--restrict' )
				}
			} )
			let contentItems = $( '.journalcomparison__content--item' )
			let restrictedItems = $( '.journalcomparison__content--restrict' )
			let disabledItems = $( '.journalcomparison__content--item-disable' )
			let visibleItems = contentItems.not( restrictedItems ).not( disabledItems ).length
			let enabledItems = contentItems.not( disabledItems ).length
			let potentials = restrictedItems.not( disabledItems ).length

			$( ".journalcomparison__total" ).html( contentItems.length )
			$( ".journalcomparison__counter" ).html( visibleItems )

			if ( enabledItems < 12 ) {
				$( '.journalcomparison__loadmore--button' ).attr( 'disabled', 'disabled' )
			} else if ( potentials == 0 ) {
				$( '.journalcomparison__loadmore--button' ).attr( 'disabled', 'disabled' )
			} else {
				$( '.journalcomparison__loadmore--button' ).removeAttr( 'disabled' )
			}
		}

		/**
		 * Assigns 1 2 3 flags to filter items as they're selected and reveals linked slider
		 */
		setFilterCounts = function ( value, target ) {
			const self = this
			const elementCheckbox = self.instance.find( '.journalcomparison__check--trigger[data-target="' + target + '"]' )

			switch ( value ) {
				case true:
					if ( self.firstFilter === '' ) {
						self.firstFilter = target
						elementCheckbox.parent().addClass( 'journalcomparison__check--first' )
						self.instance.find( '.journalcomparison__content--item-' + target ).addClass( 'journalcomparison__check--first' )
					} else if ( self.secondFilter === '' ) {
						self.secondFilter = target
						elementCheckbox.parent().addClass( 'journalcomparison__check--second' )
						self.instance.find( '.journalcomparison__content--item-' + target ).addClass( 'journalcomparison__check--second' )
					} else if ( self.thirdFilter === '' ) {
						self.thirdFilter = target
						elementCheckbox.parent().addClass( 'journalcomparison__check--third' )
						self.instance.find( '.journalcomparison__content--item-' + target ).addClass( 'journalcomparison__check--third' )
					} else {
						if ( self.thirdFilter !== '' ) {
							self.instance.find( '.journalcomparison__check--third input' ).prop( "checked", false )
							self.instance.find( '.journalcomparison__check--third' ).removeClass( 'journalcomparison__check--third' )
							self.instance.find( '.journalcomparison__content--item-' + target ).removeClass( 'journalcomparison__check--third' )
							self.thirdFilter = target
							elementCheckbox.parent().addClass( 'journalcomparison__check--third' )
						}
					}

					break
				case false:
					if ( elementCheckbox.parent().hasClass( 'journalcomparison__check--first' ) ) {
						self.firstFilter = ''
						elementCheckbox.parent().removeClass( 'journalcomparison__check--first' )
						self.instance.find( '.journalcomparison__content--item-' + target ).removeClass( 'journalcomparison__check--first' )
					}

					if ( elementCheckbox.parent().hasClass( 'journalcomparison__check--second' ) ) {
						self.secondFilter = ''
						elementCheckbox.parent().removeClass( 'journalcomparison__check--second' )
						self.instance.find( '.journalcomparison__content--item-' + target ).removeClass( 'journalcomparison__check--second' )
					}

					if ( elementCheckbox.parent().hasClass( 'journalcomparison__check--third' ) ) {
						self.thirdFilter = ''
						elementCheckbox.parent().removeClass( 'journalcomparison__check--third' )
						self.instance.find( '.journalcomparison__content--item-' + target ).removeClass( 'journalcomparison__check--third' )
					}
					break
				default:
					break
			}

			//Removes the class on every slider every load because otherwise they persist when we untick them from visibility
			self.instance.find( '.journalcomparison__slider--item-visible' ).removeClass( 'journalcomparison__slider--item-visible' )

			let showFirstSlider = self.instance.find( '.journalcomparison__check--first input' ).attr( 'data-target' )
			self.instance.find( '.journalcomparison__slider--item[data-target="' + showFirstSlider + '"]' ).addClass( 'journalcomparison__slider--item-visible' )

			let showSecondSlider = self.instance.find( '.journalcomparison__check--second input' ).attr( 'data-target' )
			self.instance.find( '.journalcomparison__slider--item[data-target="' + showSecondSlider + '"]' ).addClass( 'journalcomparison__slider--item-visible' )

			let showThirdSlider = self.instance.find( '.journalcomparison__check--third input' ).attr( 'data-target' )
			self.instance.find( '.journalcomparison__slider--item[data-target="' + showThirdSlider + '"]' ).addClass( 'journalcomparison__slider--item-visible' )

			self.findHighestData( showFirstSlider, showSecondSlider, showThirdSlider )
		}


		findHighestData = function () {
			const self = this
			self.instance.find( '.journalcomparison__content--highest' ).removeClass( 'journalcomparison__content--highest' )

			self.instance.find( '.journalcomparison__slider--item-visible input' ).each( function () {
				const thisDataType = $( this ).attr( 'data-range' )
				const thisDataTitle = $( this ).attr( 'data-title' )

				let highestOfType = {}
				let highestValue = 0

				self.instance.find( '.journalcomparison__content--item' ).not( '.journalcomparison__content--item-disable' ).each( function () {
					let thisValue = $( this ).attr( 'data-' + thisDataType )

					if ( thisValue == 'n/a' ) {
						return
					}

					if ( parseInt( thisValue ) > parseInt( highestValue ) ) {
						highestValue = thisValue
						highestOfType = $( this )
					}
				} ).promise().done( function () {
					if ( Object.keys( highestOfType ).length > 0 ) {
						if ( highestOfType.hasClass( 'journalcomparison__content--highest' ) ) {
							let currentAttr = highestOfType.attr( 'data-highlight' )
							highestOfType.attr( 'data-highlight', currentAttr + ' & ' + thisDataTitle )
							highestOfType.find( 'div[data-target="' + thisDataType + '"' ).addClass( 'journalcomparison__content--highest' )
						} else {
							highestOfType.addClass( 'journalcomparison__content--highest' ).attr( 'data-highlight', thisDataTitle )
							highestOfType.find( 'div[data-target="' + thisDataType + '"' ).addClass( 'journalcomparison__content--highest' )
						}
					}

				} )
			} )

			self.reduceResults()
		}

		hideJournal = function () {
			const self = this

			self.instance.find( '.journalcomparison__content--item' ).each( function () {
				let conditions = []
				const that = $( this )

				self.instance.find( '.journalcomparison__slider--item-visible input' ).each( function () {
					let thisDataType = $( this ).attr( 'data-range' )
					let data = that.attr( 'data-' + self.dataPoint[ thisDataType ].label )
					let value = parseInt( self.instance.find( '.journalcomparison__content--filter-range[data-range="' + self.dataPoint[ thisDataType ].label + '"]' ).val() )

					conditions.push( parseInt( data ) < value )
					conditions.push( data === 'n/a' )
				} )

				if ( conditions.includes( true ) ) {
					$( this ).addClass( 'journalcomparison__content--item-disable' )
				} else {
					$( this ).removeClass( 'journalcomparison__content--item-disable' )
				}
			} )

			self.findHighestData()
			self.reduceResults()
		}

		setRangeMax = function () {
			const self = this

			self.instance.find( '.journalcomparison__content--item' ).each( function () {
				for ( const key in self.dataPoint ) {
					let sliderValue = parseInt( self.dataPoint[ key ].sliderValue )
					let dataLabel = parseInt( $( this ).attr( 'data-' + self.dataPoint[ key ].label ) )

					if ( dataLabel > sliderValue && dataLabel !== 'n/a' ) { self.dataPoint[ key ].sliderValue = parseInt( dataLabel )}
				}
			} )

			for ( const key in self.dataPoint ) {
				self.instance.find( '.journalcomparison__content--filter-range[data-range="' + self.dataPoint[ key ].label + '"]' ).attr( 'max', self.dataPoint[ key ].sliderValue )
			}
		}

		reorderResults = function () {
			const self = this
			let orderedResults = []
			const filter = self.instance.find( '.journalcomparison__subjectcategories option' ).filter( function () {
				return this.value === self.instance.find( '.journalcomparison__subjectcategories' ).val()
			} ).data( 'value' )

			self.instance.find( '.journalcomparison__check--initial' ).removeClass( 'journalcomparison__check--initial' )
			self.instance.find( '.journalcomparison__content--item-' + filter ).addClass( 'journalcomparison__check--initial' )

			self.instance.find( '.journalcomparison__content--item' ).each( function () {
				let toStore = {}

				for ( const key in self.dataPoint ) {
					let label = self.dataPoint[ key ].label
					let dataAttr = $( this ).attr( 'data-' + label )

					toStore[ label ] = dataAttr !== 'n/a' && dataAttr !== undefined ? dataAttr : '0'
				}

				toStore[ 'element' ] = $( this )

				orderedResults.push( toStore )
			} )

			orderedResults.sort( ( a, b ) => (b[ filter ].localeCompare( a[ filter ], undefined, { numeric: true } )) )

			self.instance.find( '.journalcomparison__content--container' ).html( '' )

			for ( let x = 0; x < orderedResults.length; x++ ) {
				self.instance.find( '.journalcomparison__content--container' ).append( orderedResults[ x ].element )
			}

			self.instance.find( '.journalcomparison__content--item' ).removeClass( 'journalcomparison__content--item-disable' )
			self.reduceResults()
		}
	}

	const thisBlock = $( '.wp-block-jtf-jtf-journalcomparison' )

	if ( thisBlock.length > 0 ) {
		thisBlock.each(
			function () {
				new JOURNALCOMPARISON( $( this ) )
			},
		)
	}
} )
